var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconThunder = function SvgIconThunder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.02 8 1.37-6.09c.143-.834-.95-1.262-1.401-.55l-5.867 9.448c-.326.516.04 1.192.646 1.192H9.52l-.911 6.09c-.143.834.95 1.262 1.401.55l5.867-9.448c.326-.516-.04-1.192-.646-1.192z"
  })));
};
export default SvgIconThunder;